/**
 * Default style/color theme for the lineage canvas (plan behavior 12).
 * Edited live by StyleConfigPanel, provided to custom nodes via ThemeContext,
 * and stored on `map.settings.theme` so it round-trips with the diagram.
 */
export const DEFAULT_THEME = {
  node: {
    database: '#1976d2',
    application: '#7b1fa2',
    service: '#00897b',
    file: '#f57c00',
    api: '#c2185b',
    other: '#546e7a',
  },
  group: '#90a4ae',
  edge: {
    color: '#666',
    width: 1.5,
    highlightColor: '#1976d2',
    highlightWidth: 2.5,
  },
  handle: '#1976d2',
  fontSize: 12,
  animationSpeed: 1, // seconds per dash cycle for highlighted edges
};

/**
 * Return a COMPLETE theme by filling any missing keys from DEFAULT_THEME. A persisted
 * map may carry a partial or empty `settings.theme` (older maps, a partial Style-panel
 * save); the edge/node renderers dereference `theme.edge.*` / `theme.node.*` directly,
 * so a missing section would crash. Merge one level deep for the nested `node`/`edge`.
 */
export const mergeTheme = (theme) => {
  const t = theme || {};
  return {
    ...DEFAULT_THEME,
    ...t,
    node: {...DEFAULT_THEME.node, ...(t.node || {})},
    edge: {...DEFAULT_THEME.edge, ...(t.edge || {})},
  };
};

export const APP_TYPES = ['database', 'application', 'service', 'file', 'api', 'other'];

/** Colour for a node given its appType, falling back to `other`. */
export const nodeColor = (theme, appType) =>
  (theme && theme.node && theme.node[appType]) || (theme && theme.node && theme.node.other) || '#546e7a';
